// extracted by mini-css-extract-plugin
module.exports = {"block":"ReferralStats_block__JWIK8","title":"ReferralStats_title__I0Bdg","referreesBlock":"ReferralStats_referreesBlock__xIZMt"};